import TagHandler from './TagHandler';

export default TagHandler;
